/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "ap-south-1",
  aws_cognito_identity_pool_id:
    "ap-south-1:7022e992-a455-4754-b45c-d6e98c1e10bc",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_FRPprnFpa",
  aws_user_pools_web_client_id: "4usasolfb2bk64dluddi32s4c9",
  oauth: {},
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_cloud_logic_custom: [
    {
      name: "RekognitionFaceLivenessAPIs",
      endpoint: "https://7sz7x6n5h1.execute-api.ap-south-1.amazonaws.com/dev",
      region: "ap-south-1",
    },
  ],
};
/*
https://vknpujw3pa.execute-api.ap-south-1.amazonaws.com/UAT/getLivenessResult
https://vknpujw3pa.execute-api.ap-south-1.amazonaws.com/UAT/createLivenessSession
User pool ID :ap-south-1_FRPprnFpa
Identity pool ID : ap-south-1:7022e992-a455-4754-b45c-d6e98c1e10bc
web_app_client: 4usasolfb2bk64dluddi32s4c9
*/

export default awsmobile;
 